module.exports = __webpack_public_path__ + "static/img/4.72a1ab9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/4/eng/4.png
// module id = Jrmw
// module chunks = 0